/*** IMPORTS FROM imports-loader ***/
var define = false;

import 'objectFitPolyfill';
import slickConfig from '../../util/slickConfig';
import StickyHeader from '../../util/StickyHeader';
import detectIE from '../../util/detectIE';
import NsfwBanner from '../../util/NsfwBanner';

function slideMatchImageWidth(image) {
  image.closest('.slick-slide').style.width = `${image.getBoundingClientRect().width}px`;
}

function sliderIEFix() {
  if (detectIE()) {
    document.querySelectorAll('.carousel button.open-modal > img').forEach((image) => {
      slideMatchImageWidth(image);
    });
  }
}

function initSliderIEFixEvents() {
  // IE can't get the width of the slide properly for some reason. Force it.
  if (detectIE()) {
    document.querySelectorAll('.carousel button.open-modal > img').forEach((image) => {
      slideMatchImageWidth(image);
      image.addEventListener('load', () => slideMatchImageWidth(image));
    });
  }
}

export default () => {
  NsfwBanner.init();

  // Initialize sliders
  $(slickConfig.profileWork.selector).slick(slickConfig.profileWork.options);
  $(slickConfig.profileWorkModal.selector).slick(slickConfig.profileWorkModal.options);
  window.addEventListener(
    'load',
    () => {
      $(slickConfig.profileWork.selector).slick('refresh');
      sliderIEFix();
    },
    {
      once: true,
    },
  );

  document.querySelectorAll('.carousel button.open-modal > img').forEach((image) => {
    image.addEventListener('lazyloaded', () => {
      $(slickConfig.profileWork.selector).slick('setPosition');
    });
  });

  $(slickConfig.profileWork.selector).on('setPosition', function () {
    sliderIEFix();
  });

  StickyHeader.init(document.querySelector('body').classList.contains('home'));

  // Initialize carousel interactions
  $('section.profile-work, section.profile-work-modal, section.profile-cards').on('click', function (event) {
    var target = $(event.target);

    if (!target.is('button.consent, button.checkbox, button.open-modal, button.close-modal, .slide')) {
      return;
    }
    event.preventDefault();

    if (target.is('button.open-modal')) {
      // Open modal
      var modalElementToOpen = target.closest('section.profile-work').next();
      $('section.profile-work-modal').removeClass('open');
      $('body').addClass('modal-open');
      modalElementToOpen.addClass('open');

      // Set correct slide
      var inPageSlide = event.target.closest('.slick-slide');
      var inPageSlider = inPageSlide.parentNode;
      var inPageSlideIndex = Array.prototype.indexOf.call(
        inPageSlider.childNodes,
        inPageSlide
      );
      $('.carousel', modalElementToOpen).slick('slickGoTo', inPageSlideIndex, true);
      $('.carousel', modalElementToOpen).slick('refresh');
    }
    else {
      $('body').removeClass('modal-open');
      var modalElement = target.closest('section.profile-work-modal');
      var nonModalElement = modalElement.prev();
      modalElement.removeClass('open');

      // Set correct slide
      var modalSlide = event.target.closest('.slick-slide');
      var modalSlider = modalSlide.parentNode;
      var modalSlideIndex = Array.prototype.indexOf.call(
        modalSlider.childNodes,
        modalSlide
      );
      $('.carousel', nonModalElement).slick('slickGoTo', modalSlideIndex, true);
    }
  });

  initSliderIEFixEvents();
};

